import { useTranslation } from "react-i18next";
import SvgIcon from "../../SvgIcon";
import ToolTip from "../../tooltip";

const AddExerciseTabs = ({ addType }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <nav role="tablist" className="px-4 pt-1">
      <a
        href="/actions/refresh?addType=single"
        aria-current={!addType || addType === "single" || undefined}
      >
        {t("addExerciseTabs.singleExercise")}
      </a>
      <a
        href="/actions/refresh?addType=complex"
        aria-current={addType === "complex" || undefined}
      >
        {t("addExerciseTabs.complexes")}{" "}
        <ToolTip
          id="complex-info"
          html={t("addExerciseTabs.complexesTooltip")}
        >
          <SvgIcon
            alt={t("addExerciseTabs.infoIconAlt")}
            className="cursor-pointer"
            src="/img/new-icons/question-circle.svg"
          />
        </ToolTip>
      </a>
      <a
        href="/actions/refresh?addType=metcon"
        aria-current={addType === "metcon" || undefined}
      >
        {t("addExerciseTabs.metcon")}{" "}
        <ToolTip
          id="metcon-info"
          html={t("addExerciseTabs.metconTooltip")}
        >
          <SvgIcon
            alt={t("addExerciseTabs.infoIconAlt")}
            className="cursor-pointer"
            src="/img/new-icons/question-circle.svg"
          />
        </ToolTip>
      </a>
    </nav>
  );
};

export default AddExerciseTabs;
